<template>
  <q-expansion-item
    v-model="expandBlocks"
    :class="{ 'q-my-sm': !hideHeader }"
    style="font-size: 0.9rem;"
    dense
    :header-class="hideHeader ? 'hide-expansion-header' : 'small-expansion-toggle text-body1 q-px-none'"
    :hide-expand-icon="hideHeader"
    switch-toggle-side
  >
    <template #header>
      <div
        v-if="hideHeader"
        class="q-pa-none"
      />
      <div
        v-else
        class="row full-width q-gutter-x-xs items-center"
        style="font-size: 0.9rem;"
      >
        <q-icon
          class="q-mr-xs"
          name="far fa-box-archive"
          color="primary"
          size="xs"
        />
        <div
          v-if="!$_.isEmpty(label)"
          class="text-body1"
        >
          {{ label }}
        </div>
        <div
          v-else-if="!$_.isEmpty(modelName)"
          class="text-body1"
        >
          {{ modelName }}
        </div>
        <div
          v-if="!$_.isNil(modelId)"
          class="text-body1 text-grey-8"
        >
          (ID {{ modelId }})
        </div>
      </div>
    </template>
    <template #default>
      <div
        class="column q-ma-xs"
      >
        <div
          v-for="association in blocks"
          :key="`blocks-${association.name}`"
          class="column q-ml-md"
        >
          <div class="text-body1">
            {{ $_.startCase(association.label) }} ({{ association.changes.length }})
          </div>
          <ul class="text-body1 q-mt-none q-mb-sm q-pl-lg">
            <li
              v-for="change in association.changes"
              :key="`${association.name}-${change.id}`"
            >
              <div class="row items-center justify-start q-gutter-x-xs q-ml-xs">
                <div class="col row items-center q-gutter-x-xs">
                  <div>
                    {{ change.label }}
                  </div>
                  <div class="text-grey-8">
                    (ID {{ change.id }})
                  </div>
                </div>
                <router-link
                  v-if="!hideView"
                  :to="changeRoute(change)"
                  class="row items-center q-gutter-x-xs text-primary text-decoration-none"
                  style="font-size: 0.9rem;"
                >
                  <div>View</div>
                  <q-icon
                    name="arrow_forward"
                    size="xs"
                  />
                </router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </q-expansion-item>
</template>

<script>
import { computeCollectionVariableName } from 'src/models/model/utils/collection-utils'

export default {
  name: 'ArchiveBlocksSection',
  props: {
    modelName: {
      type: String,
      required: false,
      default: null
    },
    modelId: {
      type: String,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    blocks: {
      type: Array,
      default: () => ([]),
      required: false
    },
    hideHeader: {
      type: Boolean,
      default: false,
      required: false
    },
    hideView: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      expandBlocks: true
    }
  },
  computed: {
    blocksCount () {
      return _(this.blocks).map('changes').flatten().value().length
    }
  },
  methods: {
    changeRoute (change) {
      return {
        name: 'admin:settings-category-name-id',
        params: {
          category: 'archiving',
          name: _.kebabCase(computeCollectionVariableName(change.type)),
          id: change.id
        }
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.q-expansion-item :deep(.small-expansion-toggle >.q-item__section--avatar) {
  padding-right: 0;
  min-width: 0;
}

:deep(.hide-expansion-header) {
  min-height: 0;
  padding: 0;
}
</style>
